import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Bg from '../images/ui/dark-blue-bg.jpg';
import VideoBg from '../video/brainhearing-bg.mp4';
import Modal from './Modal';

import MagentaLine from './elements/MagentaLine';
import NewApproach from './BrainHearingTechnology/NewApproach';
import NewPolaris from './BrainHearingTechnology/NewPolaris';
import MoreSoundAmplifier from './BrainHearingTechnology/MoreSoundAmplifier';
import MoreSoundIntelligence from './BrainHearingTechnology/MoreSoundIntelligence';

import IntelIcon from '../images/brainhearing-technology/more-sound-intel-icon.png';
import AmpIcon from '../images/brainhearing-technology/more-sound-amp-icon.png';

const LEARN_MORE_BUTTON_STYLES = {
  width: '94px',
  height: '28px',
  backgroundColor: 'transparent',
  border: '1px solid rgba(255, 255, 255, 0.8)',
  textTransform: 'uppercase',
  fontWeight: 'bold',
  color: 'rgba(255, 255, 255, 1)',
  fontSize: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '10px',
  transition: 'all 0.3s',
  cursor: 'pointer',
  marginTop: '50px',
  outline: 'none',
};
const BASE_TIME = 3;
const INTERVAL = 0.4;
const anim01 = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      duration: 0.4,
      delay: BASE_TIME + 0 * INTERVAL,
    },
  },
};
const anim02 = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      duration: 0.4,
      delay: BASE_TIME + 1 * INTERVAL,
    },
  },
};
const anim03 = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      duration: 0.4,
      delay: BASE_TIME + 2 * INTERVAL,
    },
  },
};
const anim04 = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      duration: 0.4,
      delay: BASE_TIME + 3 * INTERVAL,
    },
  },
};
const anim05 = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      duration: 0.4,
      delay: BASE_TIME + 4 * INTERVAL,
    },
  },
};
export default function BrainHearingTechnologyMain() {
  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState(0);

  function openModal(val) {
    // console.log({ val });
    setIsOpen(true);
    setModalContent(val);
  }

  return (
    <div id="brainhearing-technology-wrapper">
      <img src={Bg} className="full-bg" />
      <motion.video
        src={VideoBg}
        className="full-bg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.5 }}
        loop
        autoPlay
        muted
      />
      <header>
        <MagentaLine height="68px" left="40px" />
        <div className="wordwrap" style={{ left: '22px' }}>
          <motion.div
            className="first-line"
            style={{
              fontSize: '24px',
              top: '42px',
              left: '40px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <strong>A fundamentally new</strong> approach to sound processing
          </motion.div>
        </div>
      </header>

      <motion.div
        id="new-polaris-block"
        className="block"
        variants={anim01}
        initial="hidden"
        animate="show"
      >
        <span>New Polaris™ Platform</span>
        <p>
          The world's first platform precisely engineered to
          <br /> power an on-board Deep Neural Network
        </p>
      </motion.div>
      <div id="hotspot-1" className="hotspot" onClick={() => openModal(1)} />
      <div id="hotspot-2" className="hotspot" onClick={() => openModal(2)} />
      <div id="hotspot-3" className="hotspot" onClick={() => openModal(3)} />
      <div id="hotspot-4" className="hotspot" onClick={() => openModal(4)} />
      <div id="hotspot-5" className="hotspot" onClick={() => openModal(5)} />
      <motion.button
        id="button-1"
        className="learn-more-button"
        onClick={() => openModal(1)}
        type="button"
        style={LEARN_MORE_BUTTON_STYLES}
        variants={anim01}
        initial="hidden"
        animate="show"
      >
        Learn More
      </motion.button>

      <motion.div
        id="new-approach-1"
        className="block menu"
        variants={anim02}
        initial="hidden"
        animate="show"
      >
        12 million sound scenes
        <br />
        recorded from real life
      </motion.div>
      <motion.button
        id="button-2"
        className="learn-more-button"
        onClick={() => openModal(2)}
        type="button"
        style={LEARN_MORE_BUTTON_STYLES}
        variants={anim02}
        initial="hidden"
        animate="show"
      >
        Learn More
      </motion.button>

      <motion.div
        id="new-approach-2"
        className="block menu"
        variants={anim03}
        initial="hidden"
        animate="show"
      >
        Training of a highly intelligent
        <br />
        Deep Neural Network
      </motion.div>
      <motion.button
        id="button-3"
        className="learn-more-button"
        onClick={() => openModal(3)}
        type="button"
        style={LEARN_MORE_BUTTON_STYLES}
        variants={anim03}
        initial="hidden"
        animate="show"
      >
        Learn More
      </motion.button>

      <motion.div
        id="more-sound-intel-menu"
        className="block menu icon-menu"
        variants={anim04}
        initial="hidden"
        animate="show"
      >
        <img src={IntelIcon} className="icon" />
        <span>
          MoreSound
          <br />
          Intelligence™
        </span>
      </motion.div>
      <motion.button
        id="button-4"
        className="learn-more-button"
        onClick={() => openModal(4)}
        type="button"
        style={LEARN_MORE_BUTTON_STYLES}
        variants={anim04}
        initial="hidden"
        animate="show"
      >
        Learn More
      </motion.button>

      <motion.div
        id="more-sound-amp-menu"
        className="block menu icon-menu"
        variants={anim05}
        initial="hidden"
        animate="show"
      >
        <img src={AmpIcon} className="icon" />
        <span>
          MoreSound
          <br />
          Amplifier™
        </span>
      </motion.div>
      <motion.button
        id="button-5"
        className="learn-more-button"
        onClick={() => openModal(5)}
        type="button"
        style={LEARN_MORE_BUTTON_STYLES}
        variants={anim05}
        initial="hidden"
        animate="show"
      >
        Learn More
      </motion.button>

      <Modal open={isOpen} onClose={() => setIsOpen(false)}>
        {modalContent === 1 ? <NewPolaris /> : ''}
        {modalContent === 2 ? <NewApproach /> : ''}
        {modalContent === 3 ? <NewApproach /> : ''}
        {modalContent === 4 ? <MoreSoundIntelligence /> : ''}
        {modalContent === 5 ? <MoreSoundAmplifier /> : ''}
      </Modal>
    </div>
  );
}
